import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Divider, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { TextFieldFormsy, FuseAnimate } from '@fuse';
import Formsy from 'formsy-react';
import 'velocity-animate/velocity.ui';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import Config from '../../../config';
import Modal from "react-bootstrap/es/Modal";
import axios from 'axios';
import Fingerprint2 from 'fingerprintjs2';
import { GoogleLogin } from 'react-google-login';
import { MicrosoftLogin } from 'react-microsoft-login';
import { connect } from 'react-redux';
import { setUserData } from '../../../store/actions/userActions';
import Cookies from 'universal-cookie';
import isEmpty from 'lodash/isEmpty';

const cookies = new Cookies();

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class Login extends Component {
    state = {
        error: null,
        canSubmit: false,
        show: false,
        modalMessage: '',
        fingerprint: '',
        redirectUrl: ''
    };

    componentDidMount() {
        this.extractDomainUrl(this.props.location.search);
        if (typeof this.props.history.location.message != 'undefined' && this.props.history.location.message != null) {
            let oldState = { ...this.state };
            oldState.modalMessage = this.props.history.location.message;
            oldState.show = true;
            this.setState(oldState);
            this.props.history.location.message = null;
        }
        if (window.requestIdleCallback) {
            requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                    let values = components.map(function (component) {
                        return component['value'];
                    });
                    this.setState({
                        fingerprint: Fingerprint2.x64hash128(values.join(''), 31)
                    });
                }.bind(this))
            }.bind(this))
        } else {
            setTimeout(function () {
                Fingerprint2.get(function (components) {
                    let values = components.map(function (component) {
                        return component['value'];
                    });
                    this.setState({
                        fingerprint: Fingerprint2.x64hash128(values.join(''), 31)
                    });
                }.bind(this))
            }.bind(this), 500)
        }
    }

    extractDomainUrl = (searchParam) => {
        if (searchParam) {
            let url = searchParam.split('=')[1];
            if (this.isValidUrl(decodeURIComponent(url))) {
                this.setState({ redirectUrl: decodeURIComponent(url) });
            }
        }
    }

    isValidUrl = (url) => {
        let valid;
        try {
            new URL(url);
            valid = true;
        } catch (e) {
            valid = false;
        }
        return valid;
    }

    userLogin(credentials) {
        let qs = require('qs');
        axios.post(EndpointsGetter.getAuthEndpoint(), qs.stringify({
            username: credentials.username,
            password: credentials.password,
            client_id: 'spring-security-oauth2-read-write-client',
            grant_type: 'password'
        }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.state.fingerprint
                }
            })
            .then(async response => {
                let data = response.data;
                const userAccounts = await this.getUserAccounts(data.access_token);
                this.createUserSession(response.data, userAccounts.data);
            })
            .catch(error => {
                this.loginError(error.response);
            });
    }

    getUserAccounts = async (accessToken) => {
        try {
            const response = await axiosInstance.get(EndpointsGetter.getUserAccountsEndpoint(), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            });
            return response;

        } catch (err) {
            this.loginError(err.response);
        }
    }

    createUserSession = ({ access_token, refresh_token, expires_in }, userAccounts) => {
        let cookieExpiry = Date.now() + 180 * 1000;
        const cookieDomain = window.location.href.includes('test') ? '.dev.test' : '.kanin.io';
        cookies.set('access_token', access_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('refresh_token', refresh_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('expires_in', expires_in, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('set_in', new Date().getTime(), { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });

        this.redirectUserToAccount(access_token, userAccounts);

        this.setState({
            accessToken: access_token,
            refreshToken: refresh_token,
            error: null
        });
    }

    redirectUserToAccount = (accessToken, userAccounts) => {
        if (userAccounts.length === 1) {
            if (!isEmpty(this.state.redirectUrl) && this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts)) {
                this.setAccount(userAccounts[0], accessToken);
            }
            else this.redirectToSelectAccount(accessToken, userAccounts);
        } else {
            if (!isEmpty(this.state.redirectUrl) && this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts)) {
                let loginAccount = this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts);
                this.setAccount(loginAccount, accessToken);

            } else this.redirectToSelectAccount(accessToken, userAccounts);
        }
    }

    redirectAccountBelongsToUserAccounts = (redirectUrl, userAccounts) => {
        return userAccounts.find((account) => redirectUrl.includes(account.accountUrl));
    }

    redirectToSelectAccount = (accessToken, userAccounts) => {
        this.props.history.push({
            pathname: '/select-account',
            state: {
                userAccounts: userAccounts,
                accessToken: accessToken
            }
        });
    }

    setAccount = ({ id, accountUrl }, accessToken) => {
        axiosInstance.put(`${EndpointsGetter.setUserAccountEndpoint()}/${id}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                const { access_token, expires_in, refresh_token } = response.data.tokenInfo,
                    cookieExpiry = Date.now() + 120 * 1000,
                    userCookieExpiry = Date.now() + 7200 * 1000,
                    url = window.location.href,
                    cookieDomain = url.includes('test') ? '.dev.test' : '.kanin.io';

                cookies.set('access_token', access_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('refresh_token', refresh_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('expires_in', expires_in, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('set_in', new Date().getTime(), { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('user', response.data.user, { path: '/', expires: new Date(userCookieExpiry), domain: cookieDomain });

                window.location.href = url.includes('test') ? `http://dev.test:3000/` : `https://${accountUrl}`;
            })
            .catch(error => {
                this.loginError(error.response);
            })
    }

    loginError(response) {
        if (response) {
            this.setState({
                accessToken: null,
                refreshToken: null,
                error: response.data.error_description || response.data.message
            });
        }
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    handleHideModal() {
        this.state.show = false;
        this.forceUpdate();
    }

    googleSuccess = (response) => {
        axios.post(EndpointsGetter.getGoogleLoginEndpoint(), response, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                'Fingerprint': this.state.fingerprint
            }
        })
            .then(async response => {
                let data = response.data;
                const userAccounts = await this.getUserAccounts(data.access_token);
                this.createUserSession(response.data, userAccounts.data);
            })
            .catch(error => {
                console.log('Google login error: ', error.response);
                this.loginError(error.response);
            });
    }

    googleFailure = (error) => {
        //TODO handle google oauth integration errors
    }

    microsoftAuthCallback = (error, authData) => {
        if (error) {
            console.log('ms error: ', error);

        } else {
            axios.post(EndpointsGetter.getMicrosoftLoginEndpoint(), authData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.state.fingerprint
                }
            })
                .then(async response => {
                    let data = response.data;
                    const userAccounts = await this.getUserAccounts(data.access_token);
                    this.createUserSession(response.data, userAccounts.data);
                })
                .catch(error => {
                    console.log('Microsoft login error: ', error.response);
                    this.loginError(error.response);
                });
        }
    }

    render() {
        const { classes } = this.props;
        const { canSubmit } = this.state;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 sm:flex-col md:flex-col md:p-0")}>
                <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>
                    <div className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>
                        <FuseAnimate animation="transition.expandIn">
                            <img className="w-512 mb-32" src="assets/images/logos/kanin_h.png" alt="logo" />
                        </FuseAnimate>

                        <div className={"hidden-sm hidden-xs"} style={{ color: 'white', 'bottom': '1%', 'left': '1%', 'position': 'absolute', 'fontSize': '1.5vh' }}>
                            <div style={{ 'textAlign': 'left' }}>v.{Config.versionNumber} #{Config.buildVersion}</div>
                            {Config.company}
                        </div>
                    </div>
                    <FuseAnimate animation={{ translateX: [0, '100%'] }}>
                        <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>
                            <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">
                                <Typography variant="title" className="md:w-full mb-32">LOGIN TO YOUR ACCOUNT</Typography>
                                <Formsy
                                    onValidSubmit={(model) => this.userLogin(model)}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    <div style={{ color: '#ff4d4d', marginBottom: 5, fontWeight: 600 }}>
                                        {this.state.error !== null && this.state.error === "Bad credentials" ? "Wrong username or password" : this.state.error}
                                    </div>
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="username"
                                        label="Username/Email"
                                        validations={{
                                            minLength: 1
                                        }}
                                        validationErrors={{
                                            minLength: 'Username cannot be empty'
                                        }}
                                        required
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="password"
                                        name="password"
                                        label="Password"
                                        validations={{
                                            minLength: 1
                                        }}
                                        validationErrors={{
                                            minLength: 'Password cannot be empty'
                                        }}
                                        required
                                    />
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case"
                                        aria-label="LOG IN"
                                        disabled={!canSubmit}
                                        value="legacy"
                                    >
                                        Login
                                    </Button>
                                </Formsy>
                                <a className="w-full mt-16" href="/forgotpassword" style={{ "textDecoration": "none", "fontSize": "1.58vh" }}>Forgot Password?</a>
                                <GoogleLogin
                                    clientId={Config.googleClientId}
                                    buttonText="Sign in with Google"
                                    onSuccess={this.googleSuccess}
                                    onFailure={this.googleFailure}
                                    theme='light'
                                    className='third-party-sign-in-btn my-24'
                                />
                                <MicrosoftLogin
                                    clientId={Config.msClientId}
                                    authCallback={this.microsoftAuthCallback}
                                    buttonTheme='dark'
                                    withUserData={true}
                                    debug={true}
                                    className='third-party-sign-in-btn'
                                />
                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
                <div className={"hidden-md hidden-lg hidden-xl"} style={{ color: 'white', 'bottom': '1%', 'left': '1%', 'fontSize': '1.5vh' }}>
                    v.{Config.versionNumber} #{Config.buildVersion}<br />
                    {Config.company}
                </div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title">
                            Message
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-info"
                            onClick={(e) => this.handleHideModal()}>
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

const mapDispatchToProps = {
    setUserData
};

export default withStyles(styles, { withTheme: true })(withRouter(
    connect(null, mapDispatchToProps)(Login)
));



// WEBPACK FOOTER //
// ./src/main/content/login/Login.js